module.exports = __webpack_public_path__ + "assets/img/fea571c3cfd0e14b579655aa22cc482f.png";